import axios from 'utils/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

const urls = {
  createBusiness: 'business',
  uploadImage: 'business/uploadImage',
  getAllBusiness: 'business/getAllBusiness',
  updateBusinessStatus: 'business/updateBusinessStatus',
  deleteBusiness: 'business/deleteBusiness',
  getBusinessById: 'business/getBusinessById',
  updateBusiness: 'business/updateBusiness'
};

export const getAllBusinessApi = createAsyncThunk('serviceplug/getAllBusiness', async (params, thunkApi) => {
  try {
    const response = await axios.get(urls.getAllBusiness);
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const uploadImageApi = createAsyncThunk('serviceplug/uploadImage', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.uploadImage}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    return data;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const createBusinessApi = createAsyncThunk('serviceplug/createBusiness', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.createBusiness}`,
      method: 'post',
      data: params
    });
    const data = await response.data?.result;

    return data;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const updateBusinessStatusApi = createAsyncThunk(
  'serviceplug/updateBusinessStatus',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.updateBusinessStatus}`,
        method: 'post',
        data: params
      });
      const data = await response.data?.result;
      return data;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const deleteBusinessApi = createAsyncThunk('serviceplug/deleteBusiness', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.deleteBusiness}`,
      method: 'delete',
      data: params
    });
    const data = await response.data;

    return data;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getBusinessByIdApi = createAsyncThunk('serviceplug/getBusinessById', async (params, thunkApi) => {
  try {
    const response = await axios.get(`${urls.getBusinessById}`, { params });
    if (!_.isEmpty(response.data?.result)) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const updateBusinessApi = createAsyncThunk('serviceplug/updateBusiness', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.updateBusiness}/${params._id}`,
      method: 'put',
      data: params
    });
    const data = await response.data;

    return data?.result;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});
